import { render } from "./PedidosImportados.vue?vue&type=template&id=c3bd40fc"
import script from "./PedidosImportados.vue?vue&type=script&lang=js"
export * from "./PedidosImportados.vue?vue&type=script&lang=js"

import "./PedidosImportados.vue?vue&type=style&index=0&id=c3bd40fc&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__